import React from 'react';
import SessionLayout from '../layouts/Session/Session';
import ForgotPassword from '../components/Session/ForgotPassword';
import {setPageTitle} from '../utils/helpers';

const ResetPasswordPageContainer = () => {
  setPageTitle('Reset Password | Access your UK savings accounts');

  return (
    <SessionLayout>
      <ForgotPassword pageTitle="Reset password" />
    </SessionLayout>
  );

};

export default ResetPasswordPageContainer;
